import { useGetCurrentUserQuery } from 'services';

export const useUserHasPermission = () => {
  const { data: current_user } = useGetCurrentUserQuery();

  /**
   * @description giris yapmis olan kullanicinin maddenin ait oldugu komitede sekreter veya baskan olup olmadigini kontrol eder
   * @param {number} value komitenin id degeri
   * @returns {boolean} maddenin ait oldugu komitede sekreter veya baskan olup olmadigi bilgisini döner
   */
  const handlePermission = (value) => {
    // Array.isArray kontrolü yapılarak gelen değer array ise value.includes(item.committee.id) ile kontrol yapılır bu hook genel yetki kontrolü de yaptığı için arary olarak gelmeme durumunda da doğru çalışması sağlandı.
    return Boolean(
      (current_user &&
        current_user.memberships
          .filter((item) => (Array.isArray(value) ? value.includes(item.committee.id) : item.committee.id === value))
          .find((item) => item.type === 0 || item.type === 1)) ||
        current_user.isAdmin
    );
  };
  /**
   * @description giris yapmis olan kullanicinin maddenin ait oldugu komitede olup olmadigini kontrol eder
   * @param {number} value komitenin id degeri
   * @returns {boolean} komiteye ait olup olmadigi bilgisini döner
   */
  const handleUserIsOnCommittee = (value) => {
    return Boolean((current_user && current_user.memberships.find((item) => item.committee.id === value)) || current_user.isAdmin);
  };

  /**
   * @description giris yapmis olan kullanicinin madde yazarı olup olmadigini kontrol eder
   * @param {array} authors madde yazarı listesi
   * @returns {boolean} madde yazarı olup olmadigi bilgisini döner
   */
  const authorHasPermission = (authors) => {
    return current_user?.author && Boolean(authors.some((author) => author?.author?.id === current_user?.author.id));
  };

  /**
   * @description giris yapmis olan kullanicinin madde sorumlusu olup olmadigini kontrol eder
   * @param {number} supervisorID madde sorumlusunun id degeri
   * @returns {boolean} madde sorumlusunun olup olmadigi bilgisini döner
   */
  const isArticleSupervisor = (supervisorID) => {
    return current_user && supervisorID === current_user?.id;
  };

  return { handlePermission, handleUserIsOnCommittee, isArticleSupervisor, authorHasPermission };
};
